import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'; // 正式
import IframeView from '@/components/IframeView'; // 微信内嵌iframe页面
// import Report from '@/components/Report'
// import Special from '@/components/Special'; // 专题
// import volunteer from '@/components/volunteer'; // 志愿服务地图

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/iframe-view',
      name: 'IframeView',
      component: IframeView
    },
    // {
    //   path: '/',
    //   name: 'Report',
    //   component: Report
    // },
    // {
    //   path: '/',
    //   name: 'Special',
    //   component: Special
    // },
    // {
    //   path: '/',
    //   name: 'volunteer', // 志愿部地图
    //   component: volunteer
    // },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js